import { PageHeader } from 'antd'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

const ImportMachinesPageHeader: FC = ({}) => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.machines.imports.pageHeader.title')} />
}

ImportMachinesPageHeader.displayName = 'ImportMachinesPageHeader'
export default ImportMachinesPageHeader
